import type { TOC } from '@ember/component/template-only'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { WritingLegendsReportsAccordion } from 'teacher-ui-client/components/side-nav/writing/writing-legends-reports-accordion'
import { RecentWritingLink } from 'teacher-ui-client/components/side-nav/writing/recent-writing-link'
import { WritingIdeasLink } from 'teacher-ui-client/components/side-nav/writing/writing-ideas-link'
import { LongWritesLink } from 'teacher-ui-client/components/side-nav/writing/long-writes-link'

export const WritingLegendsProductGroup: TOC<unknown> = <template>
  <SideNavProductGroup @product="writing-legends" class="bg-wl-blue-50 rounded-lg">
    <WritingLegendsReportsAccordion />
    <RecentWritingLink />
    <WritingIdeasLink />
    <LongWritesLink />
  </SideNavProductGroup>
</template>

export default WritingLegendsProductGroup
